import SendIcon from "@mui/icons-material/Send";
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { csCZ } from "@mui/x-data-grid/locales";
import { useEffect, useState } from "react";
import ModalWindow from "../components/modal/ModalWindow";
import SendRequestModal from "../components/SendRequestModal";
import { fetchAllRequests } from "../services/pozadavkyService";
import { compareDateExtended, formatDateExtended } from "../utils/dateUtils";
import { handleApiError } from "../utils/errorHandler";

export default function PozadavkyPage() {
  const [sendRequestModal, setSendRequestModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageText, setMessageText] = useState("");
  const [requests, setRequests] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      const result = await fetchAllRequests();
      if (result.success) {
        setRequests(result.data);
      } else {
        setError(handleApiError(result));
      }
      setLoading(false);
    }

    fetchData();
  }, []);

  const handleShowMessageClick = (message) => {
    setMessageText(message);
    setShowMessageModal(true);
  };
  if (loading) {
    return (
      <Box sx={{ textAlign: "center", p: 2 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    throw new Response(error.message, { status: error.status });
  }

  const columns = [
    {
      field: "id",
      minWidth: 80,
      headerName: "#",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "casVzniku",
      minWidth: 150,
      headerName: "Čas vzniku",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortComparator: compareDateExtended,
      valueGetter: (value) => (value ? formatDateExtended(value) : "-"),
    },
    {
      field: "typPozadavku",
      minWidth: 160,
      headerName: "Typ požadavku",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "predmet",
      minWidth: 180,
      headerName: "Předmět",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "stav",
      minWidth: 100,
      headerName: "Stav",
      flex: 1,
      headerAlign: "center",
      align: "center",
      valueGetter: (value) => (value === 0 ? "Čeká" : "Vyřízeno"),
    },
    {
      field: "casVyrizeni",
      minWidth: 150,
      headerName: "Čas vyřízení",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortComparator: compareDateExtended,
      valueGetter: (value) => (value ? formatDateExtended(value) : "-"),
    },
    {
      field: "odpoved",
      minWidth: 140,
      headerName: "Text / Odpověď",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="outlined"
          size="small"
          onClick={() =>
            handleShowMessageClick(
              params.row.stav === 0
                ? params.row.text
                : params.row.odpoved
                  ? params.row.odpoved
                  : "-"
            )
          }
        >
          Zobrazit
        </Button>
      ),
    },
  ];
  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Požadavky
      </Typography>
      <Box
        sx={{
          mb: 2,
          textAlign: "center",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{ mb: 4 }}
          startIcon={<SendIcon />}
          onClick={() => setSendRequestModal(true)}
        >
          Poslat nový požadavek
        </Button>
        {requests.length > 0 ? (
          <Paper>
            <DataGrid
              rows={requests}
              columns={columns}
              pageSizeOptions={[5, 10, 25, { value: -1, label: "Vše" }]}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              rowSelection={false}
              disableRowSelectionOnClick={true}
              autoWidth={false}
              getRowId={() => Math.random()}
              localeText={csCZ.components.MuiDataGrid.defaultProps.localeText}
              sx={(theme) => ({
                ...theme.components?.MuiDataGrid?.styleOverrides?.root,
                "& .MuiDataGrid-virtualScroller": {
                  overflowX: "auto",
                },
              })}
              slotProps={{
                pagination: {
                  labelRowsPerPage: "Řádků na stránku:",
                },
              }}
            />
          </Paper>
        ) : (
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography variant="body1">
              Dosud jste nevytvořili žádný požadavek.
            </Typography>
          </Box>
        )}
      </Box>

      <ModalWindow visible={sendRequestModal} setVisible={setSendRequestModal}>
        <SendRequestModal
          visible={sendRequestModal}
          setRequests={setRequests}
          setModalVisible={setSendRequestModal}
        />
      </ModalWindow>
      <ModalWindow visible={showMessageModal} setVisible={setShowMessageModal}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          {messageText}
        </Typography>
      </ModalWindow>
    </Box>
  );
}
